import { EventPlatformEntry, KmsTypeComponent } from "@kaltura/mediaspace-shared-types";

export const isDisplayingPlaylistComponent = (
    playlistEntries: EventPlatformEntry[],
    titleAreaButtons?: KmsTypeComponent[]
) => playlistEntries.length || (titleAreaButtons && titleAreaButtons.length);
